
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/the-freaks-register",
      function () {
        return require("private-next-pages/archive/the-freaks-register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/the-freaks-register"])
      });
    }
  